import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { PostAcuityScoreResponse } from "@/core/types";

import { postAcuityScore, type PostAcuityScoreVariables } from "../queryFunctions/postAcuityScore";

type UsePostAcuityScoreOptions = UseMutationOptions<
  PostAcuityScoreResponse,
  unknown,
  PostAcuityScoreVariables
>;

export function usePostAcuityScore(options: UsePostAcuityScoreOptions = {}) {
  return useMutation({
    mutationFn: postAcuityScore,
    ...options,
  });
}
